module.exports = __webpack_public_path__ + "static/media/ck.5503398d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ck.svg
// module id = 86
// module chunks = 0